import CaseLayout from './CaseLayout'
export default CaseLayout
